import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { notification, Icon } from "antd";
import axios from "axios";

import TabelaPastas from "./components/TabelaPastas/TabelaPastas";

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

const EnsinoEspecial = () => {
    const [ficheiros, setFicheiros] = useState([]);
    const [loading, setLoading] = useState(false);
    const [visibleDrawer, setVisibleDrawer] = useState(false);

    const carregarFicheirosPorAluno = () => {
        setLoading(true);

        axios({
            method: "get",
            url: "/api/ensino-especial/carregar-lista-ficheiros-por-aluno",
            params: {
                disciplinaId: localStorage.getItem("codigo_curso")
            }
        })
            .then(response => {
                setFicheiros(response.data);
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", error.response?.data ?? "Ocorreu um erro ao carregar os ficheiros.");
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const montarBotaoVoltar = () => {
        if (localStorage.getItem("opcao_voltar") != null) {
            const opcaoInfo = JSON.parse(localStorage.getItem("opcao_voltar"));
            return (
                <Link
                    to={opcaoInfo.link_voltar_curso ? opcaoInfo.link_voltar_curso : opcaoInfo.link_voltar}
                    className="botao-secundario botao-secundario-redondo"
                    onClick={() => opcaoInfo.id_curso && localStorage.setItem("codigo_curso", opcaoInfo.id_curso)}
                    style={{ marginRight: 10, display: "flex", justifyContent: "center", alignItems: "center" }}
                >
                    <Icon type="arrow-left" />
                </Link>
            );
        }
    };

    useEffect(() => {
        carregarFicheirosPorAluno();
    }, []);

    return (
        <>
            <div className="container container-body bloco-diario">
                <div className="turma-visao-geral hidden">
                    <div className="controlos controlos-fundo ">
                        <div className="bloco-esquerda"></div>
                        <div className="bloco-direita">{montarBotaoVoltar()}</div>
                    </div>
                </div>

                <TabelaPastas pastas={ficheiros} />
            </div>
        </>
    );
};

export default EnsinoEspecial;
